import { render, staticRenderFns } from "./EmailRecords.vue?vue&type=template&id=6ff2fccd&scoped=true"
import script from "./EmailRecords.vue?vue&type=script&lang=js"
export * from "./EmailRecords.vue?vue&type=script&lang=js"
import style0 from "./EmailRecords.vue?vue&type=style&index=0&id=6ff2fccd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff2fccd",
  null
  
)

export default component.exports